import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import {Modal} from 'reactstrap';
import ConsentManager from '../../../ConsentManager/ConsentManager';
import Cookies from 'js-cookie';
import {personalization, statisticTracking} from "../../../../shared/trackingScripts";

class ConsentModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: true,
            statisticScript: '',
            personalizationScript: ''
        };

        this.toggle = this.toggle.bind(this);
        this.consentCallback = this.consentCallback.bind(this);
        this.statisticHandler = this.statisticHandler.bind(this);
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        })
    };

    consentCallback = (consentState) => {
        if (consentState.statisticCheck) {
            this.statisticHandler();
        } else {
            Cookies.set('bigfoot_statistic-consent', false, {expires: 180})

            window.location.reload();
        }

        if (consentState.personalizationCheck) {
            this.personalizationHandler();
        } else {
            Cookies.set('bigfoot_personalization-consent', false, {expires: 180})
        }

        this.toggle();
    };

    statisticHandler = () => {
        let statisticScript = statisticTracking();

        this.setState({statisticScript: statisticScript}, () => {
            Cookies.set('bigfoot_statistic-consent', true, {expires: 180})
        });
    };

    personalizationHandler = () => {
        let personalizationScript = personalization();

        this.setState({personalizationScript: personalizationScript}, () => {
            Cookies.set('bigfoot_personalization-consent', true, {expires: 180})
        });
    };

    render() {
        return (
            <React.Fragment>
                <Helmet>{this.state.statisticScript}</Helmet>
                <Modal size="lg" scrollable backdrop={'static'} isOpen={this.state.modal} toggle={this.toggle}
                       keyboard={false}>
                    <ConsentManager consentCallback={this.consentCallback} pages={this.props.pages}/>
                </Modal>
            </React.Fragment>
        )
    }
}

export default ConsentModal;


